import React, { useState, useEffect, useCallback } from "react";
import ReactFlow, {
  Controls,
  Background,
  applyNodeChanges,
  applyEdgeChanges,
} from "reactflow";
import "reactflow/dist/style.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Select,
  InputValidationSm,
  DatePickerX,
  SelectAsync,
} from "../component/FormFormik";
import Table from "view/component/Table1";
import apiService from "apiService";
import moment from "moment";
import { showLoading, toast } from "view/component/Alert";
import ModalPedegre from "./ModalPedegre";

const ValidateSchema = Yup.object().shape({
  pedigree_relationship_type_id: Yup.string().required("Hubungan harus diisi"),
  name: Yup.string().required("Nama harus diisi"),
  address: Yup.string().required("Alamat harus diisi"),
  birthdate: Yup.string().required("Tgl Lahir harus diisi"),
  icd_code: Yup.string().required("icd harus diisi"),
});
const Index = (props) => {
  const [state, setstate] = useState({
    patient_id: props.detilPx?.patients?.id,
    name: "",
    address: props.detilPx?.villages
      ? ` ${props.detilPx?.patients?.address}, ${props.detilPx?.villages.name}, ${props.detilPx?.villages?.district?.name}, ${props.detilPx?.villages?.district?.city?.name}  `
      : "",
    birthdate: new Date(),
    pedigree_relationship_type_id: "",
    icd_code: [],
    target: null,
  });
  const [InputIcd, setInputIcd] = useState("");
  const [relations, setRelations] = useState([]);
  const [pedigreeDatas, setpedigreeDatas] = useState([]);
  const [modal, setmodal] = useState(false);
  const [diagramDatas, setdiagramDatas] = useState([]);
  const [diagramLines, setdiagramLines] = useState([]);

  const retrieveDataAsynchronouslyIcd = async () => {
    let options = [];
    const res = await apiService.get(
      "management/icd10/read?keyword=" + InputIcd
    );
    if (res.code === 200) {
      res.data.data.map((val) => {
        options.push({ value: val.code, label: val.name });
      });
    }
    return options;
  };
  const getRelation = async () => {
    const res = await apiService.get("/management/pedigree-relationship/read");
    if (res?.code === 200) {
      setRelations(res.data);
    }
  };
  useEffect(() => {
    getRelation();
  }, [relations.length]);

  const Post = async () => {
    showLoading("sedang menyimpna Data");
    let param = {
      ...state,
      birthdate: moment(state.birthdate).format("YYYY-MM-DD"),
      icd_code: state.icd_code.map((a) => {
        return a.value;
      }),
    };
    const res = await apiService.post("/registration/pedigree/create", param);
    if (res.code === 200 || res.code === 201) {
      getPedigree();
      toast({ text: "Berhasil ditambahkan", status: "success" });
    }
  };

  const getPedigree = async () => {
    const res = await apiService.get(
      "/registration/pedigree/read/patient/" + state.patient_id
    );
    if (res?.code === 200) {
      setpedigreeDatas(res.data);
      let dt = [];
      let target = [];
      res.data.map((d, i) => {
        dt.push({
          id: `${d.relation[0].pedigree.id}-${d.target}`,
          data: {
            label: (
              <div>
                <div>{d.name}</div>

                {CreateDiagnose(d.diagnoses)}
              </div>
            ),
            // label: 'coba'
          },
          position: { x: 0, y: 0 },
          level: `${d.relation[0].pedigree.parent_id}`,
        });
        target.push({
          id: `${d.relation[0].pedigree.id}-${d.target}`,
          source: `${d.relation[0].pedigree.id}-${d.target}`,
          target: d.target == null ? "null" : `${d.target}-null`,
          label: `${d.relation[0].pedigree.name}`,
          type: "step",
        });
      });
      dt.sort(function (a, b) {
        return a.level - b.level;
      });
      dt.push({
        id: "null",
        data: { label: props.detilPx?.patients?.name },
        position: { x: 370, y: 200 },
        level: "3",
      });
      let lv1 = 0;
      let lv2 = 1;
      let lv3 = 0;
      dt.map((d, indx) => {
        if (parseInt(d.level) == 1) {
          dt[indx] = { ...d, position: { x: parseInt(lv1) * 250, y: 0 } };
          lv1 = lv1 + 1;
        } else if (parseInt(d.level) == 2) {
          dt[indx] = { ...d, position: { x: parseInt(lv2) * 250, y: 100 } };
          lv2 = lv2 + 1;
        }
      });
      setdiagramDatas(dt);
      setdiagramLines(target);
    }
  };
  useEffect(() => {
    getPedigree();
  }, [pedigreeDatas.length]);

  const CreateDiagnose = (datas) => {
    return (
      <div>
        {datas.map((a) => (
          <div>
            <h5>
              {a.icd_code} - {a.icd10?.name}{" "}
            </h5>
          </div>
        ))}
      </div>
    );
  };
  //flow
  // const [initialNodes, setinitNodes] = useState([
  //   {
  //     id: "1",
  //     data: {
  //       label: (
  //         <div>
  //           <div>Grandfather</div>
  //           <div>J00 pusing</div>
  //         </div>
  //       ),
  //     },
  //     position: { x: 0, y: 0 },
  //   },
  //   {
  //     id: "2",
  //     data: { label: "grandmother" },
  //     position: { x: 250, y: 0 },
  //   },
  //   {
  //     id: "3",
  //     data: { label: "ibu" },
  //     position: { x: 125, y: 100 },
  //   },
  //   {
  //     id: "4",
  //     data: { label: "Grandfather" },
  //     position: { x: 500, y: 0 },
  //   },
  //   {
  //     id: "5",
  //     data: { label: "grandmother" },
  //     position: { x: 750, y: 0 },
  //   },
  //   {
  //     id: "6",
  //     data: { label: "ayah" },
  //     position: { x: 625, y: 100 },
  //   },
  //   {
  //     id: "7",
  //     data: { label: "Pasien" },
  //     position: { x: 385, y: 200 },
  //   },
  // ]);

  // const [initialEdges, setInitedges] = useState([
  //   { id: "1-3", source: "1", target: "3", label: "ayah", type: "step" },
  //   { id: "2-3", source: "2", target: "3", label: "ibu", type: "step" },
  //   { id: "4-6", source: "4", target: "6", label: "ayah", type: "step" },
  //   { id: "5-6", source: "5", target: "6", label: "ibu", type: "step" },
  //   { id: "3-7", source: "3", target: "7", label: "ayah", type: "step" },
  //   { id: "6-7", source: "6", target: "7", label: "ibu", type: "step" },
  // ]);
  // const [nodes, setNodes] = useState(initialNodes);
  // const [edges, setEdges] = useState(initialEdges);

  const onNodesChange = useCallback(
    (changes) => setdiagramDatas((nds) => applyNodeChanges(changes, nds)),
    []
  );
  const onEdgesChange = useCallback(
    (changes) => setdiagramLines((eds) => applyEdgeChanges(changes, eds)),
    []
  );
  //end flow
  return (
    <div>
      <div className="card">
        <div className="card-header">Family Histories</div>
        <div className="card-body">
          <Formik
            enableReinitialize
            initialValues={{
              ...state,
              icd_code: state.icd_code[0] ? state.icd_code[0].value : [],
            }}
            validationSchema={ValidateSchema}
            onSubmit={() => {
              Post();
            }}
          >
            {({ values, errors, touched }) => (
              <Form>
                <Select
                  name="pedigree_relationship_type_id"
                  onChange={(e) =>
                    setstate({
                      ...state,
                      pedigree_relationship_type_id: e.target.value,
                    })
                  }
                  value={values.pedigree_relationship_type_id}
                  errors={errors}
                  touched={touched}
                  label="Hubungan Keluarga"
                  option={relations}
                />
                <Select
                  name="target"
                  onChange={(e) =>
                    setstate({
                      ...state,
                      target: e.target.value,
                    })
                  }
                  value={values.target}
                  errors={errors}
                  touched={touched}
                  label="From"
                  option={relations}
                />
                <InputValidationSm
                  name="name"
                  value={values.name}
                  errors={errors}
                  touched={touched}
                  label="Nama"
                  type="text"
                  onChange={(e) => setstate({ ...state, name: e.target.value })}
                />
                <InputValidationSm
                  name="address"
                  value={values.address}
                  errors={errors}
                  touched={touched}
                  label="Alamat"
                  type="text"
                  onChange={(e) =>
                    setstate({ ...state, address: e.target.value })
                  }
                />
                <div className="form-group">
                  <div className="row col-md-12">
                    <div className="col-md-4">
                      <label className="form-control-label" htmlFor="tanggal">
                        Tanggal
                      </label>
                    </div>
                    <div className="col-md-8">
                      <DatePickerX
                        class="form-control form-control-sm col-md-12"
                        startDate={state.birthdate}
                        setStartDate={(e) =>
                          setstate({ ...state, birthdate: e })
                        }
                      />
                    </div>
                  </div>
                </div>
                <SelectAsync
                  name="icd_code"
                  onInputChange={(e) => setInputIcd(e)}
                  onChange={(e) => setstate({ ...state, icd_code: e })}
                  value={values.icd_code}
                  placeholder="Penyakit Kronis"
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Penyakit Kronis"
                  isMulti={true}
                  loadOptions={() => retrieveDataAsynchronouslyIcd()}
                />

                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
                {/* <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => setmodal(true)}
                >
                  Get Data
                </button> */}
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => props.history.push("/pelayanan")}
                >
                  Tutup
                </button>
              </Form>
            )}
          </Formik>
          {modal ? (
            <ModalPedegre show={modal} onHide={() => setmodal(false)} />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="card" name="flowChart">
        <div className="card-body" style={{ width: "100%", height: 400 }}>
          {console.log(diagramDatas)}
          <ReactFlow
            nodes={diagramDatas}
            onNodesChange={onNodesChange}
            edges={diagramLines}
            onEdgesChange={onEdgesChange}
            style={{ width: 800, height: 600 }}
          >
            <Background />
            <Controls />
          </ReactFlow>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <Table
            headers={[
              "NO",
              "Nama",
              "Hubungan Keluarga",
              "Tgl Lahir",
              "Penyakit Kronis",
              "Alamat",
            ]}
            columnMapper={(datas, key) => [
              datas.name,
              relations.find(
                (e) => e.id === datas.relation[0].pedigree_relationship_type_id
              )?.name,
              datas.birthdate,
              datas.diagnoses.length > 0 ? CreateDiagnose(datas.diagnoses) : "",
              datas.address,
            ]}
            data={pedigreeDatas}
            // url={"pcare/log"}
            // bodyRequest={param}
            // callback={this.changePage}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
